'use client';

import React, { createContext, useContext } from 'react';

export type MyAccountType = 'wbc' | 'water' | 'irrigator';

// The canonical order URL stored in Contentstack; only this exact value is rewritten.
const ORDER_URL = 'https://water.srpnet.com/order';

// Context carries the account type supplied by the consuming application via the web-component attribute.
const MyAccountTypeContext = createContext<MyAccountType | undefined>(undefined);

// Provider that exposes the account type to all descendants in the web-component React tree.
export const MyAccountTypeProvider = ({
  accountType,
  children,
}: {
  accountType?: MyAccountType;
  children: React.ReactNode;
}) => (
  <MyAccountTypeContext.Provider value={accountType}>{children}</MyAccountTypeContext.Provider>
);

// Read the active account type (undefined when not inside a web component or attribute not set).
export const useMyAccountType = (): MyAccountType | undefined => useContext(MyAccountTypeContext);

// Rewrite the order URL based on account type; all other hrefs are returned unchanged.
// 'water' is the default path — no rewrite needed.
export const resolveOrderUrl = (
  href: string | undefined,
  accountType: MyAccountType | undefined,
): string | undefined => {
  if (!href || !accountType || accountType === 'water') return href;
  if (href !== ORDER_URL) return href;
  return `https://water.srpnet.com/${accountType}/order`;
};
